const ThaiFlag = () => {
  return (
    <div className="h-6 w-6 rounded-full overflow-hidden">
      <div className="h-[16%] w-full bg-[#A51931]"/>
      <div className="h-[16%] w-full bg-[#F4F5F8]"/>
      <div className="h-[36%] w-full bg-[#2D2A4A]"/>
      <div className="h-[16%] w-full bg-[#F4F5F8]"/>
      <div className="h-[16%] w-full bg-[#A51931]"/>
    </div>
  )
}

export default ThaiFlag